<template>
  <LayoutSite>
    <Formulario>
      <v-card flat class="mx-auto" v-if="excluir">
        <v-card-title>
          <v-label bold>ID Prazo: {{prazo.id}}</v-label>
          <v-spacer></v-spacer>
          <v-chip class="ma-2" small>Incluído por: {{prazo.solicitante}} em {{prazo.datainclusao}}</v-chip>
          <v-chip class="ma-2" small @click="VisualizarDistribuicao()" v-if="!isCalculista" >Distribuição</v-chip>
          <v-spacer></v-spacer>
          <v-btn :color="prazo.cor_status" dark>{{prazo.status}}</v-btn>
        </v-card-title>
      </v-card>
      <template>
        <v-card flat>
          <v-tabs v-model="tab" centered>
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#tabPrazo">PRAZO</v-tab>
            <v-tab href="#tabTratamento" v-if="excluir">TRATAMENTO</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item key="1" value="tabPrazo">
              <v-card flat>
                <v-card-text>
                  <v-card class="mx-auto">
                    <v-toolbar color="#2A3F54" class="tbTitle" dark>
                      <v-toolbar-title>Processo</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="esconder('processo')">
                        <v-icon>{{iconeprocesso}}</v-icon>
                      </v-btn>
                    </v-toolbar>

                    <v-card-text v-if="dadosprocesso">
                      <v-row class="row-form">
                        <v-col cols="4">
                          <v-autocomplete
                            label="Empresa"
                            v-model="prazo.empresa_id"
                            :items="empresas"
                            item-text="nome"
                            item-value="id"
                            autofocus
                            clearable
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="4">
                          <v-autocomplete
                            label="Escritório"
                            v-model="prazo.escritorio_id"
                            :items="escritorios"
                            item-text="nome"
                            item-value="id"
                            clearable
                            @blur="carregar('advogado')"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="4">
                          <v-autocomplete
                            label="Advogado"
                            v-model="prazo.advogado_id"
                            :items="advogados"
                            item-text="nome"
                            item-value="id"
                            clearable
                            :disabled="advogadoDisabled"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row class="row-form">
                        <v-col cols="4">
                          <v-text-field label="Nº Processo" v-model="prazo.numero"></v-text-field>
                        </v-col>
                        <v-col cols="2">
                          <v-autocomplete
                            label="UF"
                            v-model="prazo.estado_id"
                            :items="estados"
                            item-text="UF"
                            item-value="id"
                            clearable
                            @blur="carregar('cidade')"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                          <v-autocomplete
                            label="Cidade"
                            v-model="prazo.cidade_id"
                            :items="cidades"
                            item-text="nome"
                            item-value="id"
                            clearable
                            :disabled="cidadeDisabled"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row class="row-form">
                        <v-col cols="6">
                          <v-text-field label="Reclamante" v-model="prazo.reclamante"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field label="Reclamada" v-model="prazo.reclamada"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-alert
                        dense
                        outlined
                        type="error"
                        v-for="(erro, index) of errosproc"
                        :key="index"
                      >{{erro[0]}}</v-alert>
                    </v-card-text>
                  </v-card>
                  <br />
                  <v-card class="mx-auto">
                    <v-toolbar color="#2A3F54" class="tbTitle" dark>
                      <v-toolbar-title>Solicitação</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="esconder('solicitacao')">
                        <v-icon>{{iconesolicitacao}}</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text v-if="dadossolicitacao">
                      <v-row class="row-form">
                        <v-col cols="3">
                          <v-autocomplete
                            label="Tipo Ato"
                            v-model="prazo.tipoato"
                            :items="tiposato"
                            item-text="nome"
                            item-value="id"
                            clearable
                            @blur="carregar('tipo')"
                          ></v-autocomplete>
                        </v-col>
                        <v-spacer></v-spacer>

                        <v-col cols="3">
                          <v-autocomplete
                            label="Responsável"
                            v-model="prazo.responsavel_id"
                            :items="usuarios"
                            item-text="name"
                            item-value="id"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row class="row-form">
                        <v-col cols="3">
                          <v-autocomplete
                            label="Tipo Prazo"
                            v-model="prazo.tipo_id"
                            :items="tipos"
                            item-text="nome"
                            item-value="id"
                            clearable
                            :disabled="tipoDisabled"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="3">
                          <v-text-field label="Solicitação" v-model="prazo.solicitacao" clearable></v-text-field>
                        </v-col>

                        <v-col cols="3">
                          <v-menu
                            ref="dtsolic"
                            v-model="dtsolic"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="prazo.datasolicitacao"
                                label="Data Solicitação"
                                persistent-hint
                                @blur="datasolic = parseDate(prazo.datasolicitacao)"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="datasolic" no-title @input="dtsolic = false"></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="3">
                          <v-menu
                            ref="dtfatal"
                            v-model="dtfatal"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="prazo.datafatal"
                                label="Data Fatal"
                                persistent-hint
                                @blur="datafatal = parseDate(prazo.datafatal)"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="datafatal" no-title @input="dtfatal = false"></v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                      <v-row class="row-form">
                        <v-col cols="12">
                          <v-textarea label="Observações" rows="1" v-model="prazo.observacao"></v-textarea>
                        </v-col>
                      </v-row>
                      <v-alert
                        dense
                        outlined
                        type="error"
                        v-for="(erro, index) of errossolic"
                        :key="index"
                      >{{erro[0]}}</v-alert>
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item key="2" value="tabTratamento">
              <v-card flat>
                <v-card-text>
                  <!-- Tratamento -->
                  <v-card class="mx-auto">
                    <v-toolbar color="#2A3F54" class="tbTitle" dark>
                      <v-toolbar-title>Tratamento</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="esconder('tratamento')">
                        <v-icon>{{iconetratamento}}</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text v-if="dadostratamento">
                      <v-col cols="12">
                        <v-row>
                          <v-spacer></v-spacer>
                          <v-btn
                            depressed
                            color="teal"
                            v-if="!EditTratamento && EmTratamento && !realizado"
                            dark
                            @click="editarTratamento()"
                            :disabled="!permissoes.tratamento_alterar"
                          >Editar</v-btn>
                        </v-row>
                      </v-col>
                      <v-row class="row-form" v-if="EditTratamento">
                        <v-col cols="1">
                          <v-btn
                            depressed
                            color="red"
                            style="margin-top:15px"
                            dark
                            v-if="!realizado"
                            @click="confirmaDevolver()"
                            :disabled="!permissoes.tratamento_excluir"
                          >Devolver</v-btn>
                        </v-col>
                        <v-col cols="10">
                          <v-textarea
                            label="Observações"
                            rows="1"
                            v-model="tratamento.observacao"
                            ref="obstratamento"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="1">
                          <v-btn
                            depressed
                            color="primary"
                            style="margin-top:15px"
                            dark
                            v-if="!realizado"
                            @click="confirmaTratamento('editar')"
                            :disabled="!permissoes.tratamento_alterar"
                          >SALVAR</v-btn>
                        </v-col>
                      </v-row>
                      <v-data-table :headers="headersTrata" :items="itemsTrata">
                        <template v-slot:item="props">
                          <tr>
                            <td class="text-xs-right">{{ props.item.usuario }}</td>
                            <td class="text-xs-right">{{props.item.created_at }}</td>
                            <td class="text-xs-right">{{props.item.dataconclusao }}</td>
                            <td class="text-xs-right">{{props.item.observacao }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                      <v-alert
                        dense
                        outlined
                        type="error"
                        v-for="(erro, index) of errostra"
                        :key="index"
                      >{{erro[0]}}</v-alert>
                    </v-card-text>
                  </v-card>
                  <br />
                  <!-- Pendências -->
                  <v-card class="mx-auto">
                    <v-toolbar color="#2A3F54" class="tbTitle" dark>
                      <v-toolbar-title>Pendências</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="esconder('pendencias')">
                        <v-icon>{{iconependencias}}</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text v-if="dadospendencias">
                      <v-col cols="12">
                        <v-row>
                          <v-btn
                            depressed
                            color="primary"
                            v-if="!EditPendencia && !NovaPendencia && !realizado"
                            dark
                            @click="frmPendencia('novo')"
                          >Nova Pendência</v-btn>
                        </v-row>
                      </v-col>
                      <v-row class="row-form" v-if="NovaPendencia">
                        <v-col cols="2">
                          <v-autocomplete
                            label="Tipo Pendência"
                            v-model="pendencia.pendenciatipo_id"
                            :items="tipospendencia"
                            item-text="nome"
                            item-value="id"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="9">
                          <v-textarea label="Observações" rows="1" v-model="pendencia.observacao"></v-textarea>
                        </v-col>
                        <v-col cols="1">
                          <v-btn
                            depressed
                            color="primary"
                            style="margin-top:15px"
                            dark
                            v-if="!realizado"
                            @click="salvarPendencia('novo')"
                            :disabled="!permissoes.pendencia_incluir"
                          >SALVAR</v-btn>
                        </v-col>
                      </v-row>
                      <v-row class="row-form" v-if="EditPendencia">
                        <v-col cols="1">
                          <v-btn
                            depressed
                            color="red"
                            style="margin-top:15px"
                            dark
                            v-if="!realizado"
                            @click="confirmaExcluir('pendencia')"
                            :disabled="!permissoes.pendencia_excluir"
                          >Excluir</v-btn>
                        </v-col>
                        <v-col cols="2">
                          <v-autocomplete
                            label="Tipo Pendência"
                            v-model="pendencia.pendenciatipo_id"
                            :items="tipospendencia"
                            item-text="nome"
                            item-value="id"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                          <v-textarea label="Observações" rows="1" v-model="pendencia.observacao"></v-textarea>
                        </v-col>
                        <v-col cols="2">
                          <v-switch v-model="pendencia.realizada" label="Finalizada"></v-switch>
                        </v-col>
                        <v-col cols="1">
                          <v-btn
                            depressed
                            color="primary"
                            style="margin-top:15px"
                            dark
                            @click="salvarPendencia('editar')"
                            :disabled="!permissoes.pendencia_alterar"
                          >SALVAR</v-btn>
                        </v-col>
                      </v-row>
                      <v-data-table :headers="headersPend" :items="itemsPend">
                        <template v-slot:item="props">
                          <tr @dblclick="frmPendencia('editar', props.item)">
                            <td class="text-xs-right">{{ props.item.usuario }}</td>
                            <td class="text-xs-right">{{props.item.tipo }}</td>
                            <td class="text-xs-right">{{props.item.created_at }}</td>
                            <td class="text-xs-right">{{props.item.dataconclusao }}</td>
                            <td class="text-xs-right">{{props.item.realizadopor }}</td>
                            <td class="text-xs-right">{{props.item.observacao }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                      <v-alert
                        dense
                        outlined
                        type="error"
                        v-for="(erro, index) of errospen"
                        :key="index"
                      >{{erro[0]}}</v-alert>
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </template>
      <!-- Botoes de ação -->
      <v-card flat class="mx-auto">
        <v-alert dense outlined type="error" v-for="(erro, index) of erros" :key="index">{{erro[0]}}</v-alert>
        <v-card-actions>
          <v-btn
            depressed
            color="error"
            @click="confirmaExcluir()"
            v-if="excluir && !realizado"
            :disabled="!permissoes.prazo_excluir"
          >EXCLUIR</v-btn>
          <v-btn depressed color="primary" @click="voltar()" v-if="!excluir || realizado">VOLTAR</v-btn>

          <v-row justify="center" v-if="excluir">
            <v-btn
              depressed
              color="cyan"
              justify="center"
              @click="TratarPrazo()"
              dark
              v-if="!EmTratamento  && !realizado"
              :disabled="!permissoes.tratamento_incluir"
            >TRATAR</v-btn>
            <v-btn
              depressed
              color="teal"
              justify="center"
              @click="ConcluirPrazo()"
              dark
              v-if="EmTratamento  && !realizado"
              :disabled="!permissoes.tratamento_alterar"
            >CONCLUIR</v-btn>
            <v-btn
              depressed
              color="black"
              justify="center"
              @click="FinalizarPrazo()"
              dark
              v-if="PodeFinalizar && !realizado"
            >Finalizar</v-btn>
          </v-row>
          <v-spacer v-if="!excluir || realizado"></v-spacer>
          <v-btn
            depressed
            color="primary"
            @click="salvar()"
            v-if="!realizado"
            :disabled="!btnSalvar"
          >SALVAR</v-btn>
        </v-card-actions>
      </v-card>
      <!-- Modal Excluir-->
      <template>
        <v-row justify="center">
          <v-dialog v-model="exclusao" persistent max-width="400">
            <v-card>
              <v-card-title class="headline">Atenção</v-card-title>
              <v-card-text>Deseja realmente excluir este prazo?</v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="red darken-1" text @click="exclusao = false">NÃO</v-btn>
                <v-btn color="blue darken-1" text @click="deletar()">SIM</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!-- Modal Tratar -->
      <template>
        <v-row justify="center">
          <v-dialog v-model="tratar" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">Deseja realmente tratar este Prazo?</v-card-title>
              <v-card-text>
                <v-col cols="12">
                  <v-autocomplete
                    label="Usuário"
                    v-model="tratamento.user_id"
                    :items="usuarios"
                    item-text="name"
                    item-value="id"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    label="Observações"
                    rows="3"
                    v-model="tratamento.observacao"
                    autofocus
                  ></v-textarea>
                </v-col>
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="red darken-1" text @click="tratar = false">NÃO</v-btn>
                <v-btn color="blue darken-1" text @click="confirmaTratamento()">SIM</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!-- Modal Concluir -->
      <template>
        <v-row justify="center">
          <v-dialog v-model="concluir" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">Deseja realmente concluir este Prazo?</v-card-title>
              <v-card-text>
                <v-col cols="12">
                  <v-autocomplete
                    label="Usuário"
                    v-model="tratamento.user_id"
                    :items="usuarios"
                    item-text="name"
                    item-value="id"
                    disabled
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    label="Observações"
                    rows="3"
                    v-model="tratamento.observacao"
                    autofocus
                  ></v-textarea>
                </v-col>
              </v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="red darken-1" text @click="concluir = false">NÃO</v-btn>
                <v-btn color="blue darken-1" text @click="confirmaConcluir()">SIM</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!-- Modal Devolver-->
      <template>
        <v-row justify="center">
          <v-dialog v-model="devolver" persistent max-width="400">
            <v-card>
              <v-card-title class="headline">Atenção</v-card-title>
              <v-card-text>Deseja realmente devolver este prazo?</v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="red darken-1" text @click="devolver = false">NÃO</v-btn>
                <v-btn color="blue darken-1" text @click="devolverPrazo()">SIM</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!-- Modal excluirPendencia-->
      <template>
        <v-row justify="center">
          <v-dialog v-model="excluirPendencia" persistent max-width="400">
            <v-card>
              <v-card-title class="headline">Atenção</v-card-title>
              <v-card-text>Deseja realmente excluir esta pendência?</v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="red darken-1" text @click="excluirPendencia = false">NÃO</v-btn>
                <v-btn color="blue darken-1" text @click="deletarPendencia()">SIM</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!-- Modal Finalizar-->
      <template>
        <v-row justify="center">
          <v-dialog v-model="finalizar" persistent max-width="500">
            <v-card>
              <v-card-title class="headline">Deseja realmente finalizar este prazo?</v-card-title>
              <v-card-text>Ao finalizar, o prazo não poderá mais ser alterado e todas os tratamentos e pendências serão concluidos</v-card-text>

              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="red darken-1" text @click="finalizar = false">NÃO</v-btn>
                <v-btn color="blue darken-1" text @click="confirmaFinalizar()">SIM</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <!-- Distribuição -->
      <template>
        <v-row justify="center">
          <v-dialog v-model="distribuicao" max-width="600">
            <Distribuicao></Distribuicao>
          </v-dialog>
        </v-row>
      </template>
    </Formulario>
  </LayoutSite>
</template>
<script>
import LayoutSite from "@/components/layout/LayoutSite";
import Formulario from "@/components/Form";
import Distribuicao from "@/components/Distribuicao";

export default {
  components: {
    LayoutSite,
    Formulario,
    Distribuicao
  },
  data() {
    return {
      tab: "tabPrazo",
      btnSalvar: true,
      EditPendencia: false,
      NovaPendencia: false,
      EditTratamento: false,
      EmTratamento: false,
      devolver: false,
      excluir: false,
      excluirPendencia: false,
      exclusao: false,
      tratar: false,
      concluir: false,
      loading: true,
      dadosprocesso: true,
      dadossolicitacao: true,
      dadostratamento: true,
      dadospendencias: true,
      dtsolic: false,
      dtfatal: false,
      PodeFinalizar: false,
      finalizar: false,
      realizado: false,
      distribuicao: false,
      isCalculista: false,
      datasolic: new Date().toISOString().substr(0, 10),
      datafatal: new Date().toISOString().substr(0, 10),
      iconeprocesso: "mdi-minus",
      iconesolicitacao: "mdi-minus",
      iconetratamento: "mdi-minus",
      iconependencias: "mdi-minus",
      tipospendencia: [],
      erros: [],
      errosproc: [],
      errossolic: [],
      errostra: [],
      errospen: [],
      empresas: [],
      escritorios: [],
      advogados: [],
      estados: [],
      cidades: [],
      usuarios: [],
      tipos: [],
      mensagens: [],
      prazo: {
        id: 0,
        empresa_id: 0,
        escritorio_id: 0,
        advogado_id: 0,
        numero: "",
        estado_id: 0,
        cidade_id: 0,
        reclamante: "",
        reclamada: "",
        tipoato: 0,
        tipo_id: 0,
        solicitacao: "",
        datasolicitacao: this.formatDate(
          new Date().toISOString().substr(0, 10)
        ),
        datafatal: this.formatDate(new Date().toISOString().substr(0, 10)),
        observacao: "",
        status_id: 1
      },
      tratamento: {
        id: 0,
        user_id: 0,
        calculo_id: 0,
        created_at: this.formatDate(new Date().toISOString().substr(0, 10)),
        observacao: ""
      },
      pendencia: {
        id: 0,
        user_id: 0,
        calculo_id: 0,
        data: this.formatDate(new Date().toISOString().substr(0, 10)),
        observacao: "",
        realizada: false
      },
      headersTrata: [
        { text: "Usuario", value: "usuario", align: "left" },
        { text: "Data Tratamento", value: "created_at" },
        { text: "Data Conclusão", value: "dataconclusao" },
        { text: "Observação", value: "observacao" }
      ],
      itemsTrata: [],
      headersPend: [
        { text: "Solicitante", value: "usuario", align: "left" },
        { text: "Tipo", value: "tipo", align: "left" },
        { text: "Solicitado em", value: "created_at" },
        { text: "Realizado em", value: "dataconclusao" },
        { text: "Realizado por", value: "realizadopor", align: "left" },
        { text: "Observação", value: "observacao" }
      ],
      itemsPend: [],
      tiposato: [
        { id: 1, nome: "Execução" },
        { id: 2, nome: "Provisão" }
      ],
      permissoes: {
        prazo: false,
        prazo_incluir: false,
        prazo_alterar: false,
        prazo_excluir: false,
        tratamento: false,
        tratamento_incluir: false,
        tratamento_alterar: false,
        tratamento_excluir: false,
        pendencia: false,
        pendencia_incluir: false,
        pendencia_alterar: false,
        pendencia_excluir: false
      }
    };
  },
  created: function() {
    this.getData();
    let usuario = this.$store.getters.getUsuario;
    if (usuario) {
      this.pendencia.user_id = usuario.id;
      this.tratamento.user_id = usuario.id;
    }
    this.loading = false;

    let permAux = this.$store.getters.getPermissoes;

    if (permAux.ativo) {
      this.permissoes = permAux;
      if (!this.permissoes.prazo) this.$router.push("/#");
    } else this.$router.push("/#");

    this.isCalculista = (usuario.perfil_id ==3);
  },
  watch: {
    datasolic(val) {
      this.prazo.datasolicitacao = this.formatDate(this.datasolic);
    },
    datafatal(val) {
      this.prazo.datafatal = this.formatDate(this.datafatal);
    }
  },
  computed: {
    cidadeDisabled() {
      return this.prazo.estado_id === 0;
    },
    advogadoDisabled() {
      return this.prazo.escritorio_id === 0;
    },
    tipoDisabled() {
      return this.prazo.tipoato === 0;
    }
  },
  methods: {
    voltar() {
      window.history.back();
    },
    VisualizarDistribuicao() {
      this.distribuicao = !this.distribuicao;
    },
    carregar(obj) {
      switch (obj) {
        case "cidade":
          this.$http
            .get(this.$urlAPI + "/cidade/porestado/" + this.prazo.estado_id, {
              headers: {
                authorization: "Bearer " + this.$store.getters.getToken
              }
            })
            .then(response => (this.cidades = response.data));
          break;
        case "advogado":
          this.$http
            .get(
              this.$urlAPI +
                "/advogado/doescritorio/" +
                this.prazo.escritorio_id,
              {
                headers: {
                  authorization: "Bearer " + this.$store.getters.getToken
                }
              }
            )
            .then(response => (this.advogados = response.data));

          this.$http
            .get(this.$urlAPI + "/escritorio/" + this.prazo.escritorio_id, {
              headers: {
                authorization: "Bearer " + this.$store.getters.getToken
              }
            })
            .then(
              response =>
                (this.prazo.responsavel_id = response.data.responsavel_id)
            );
          break;
        case "tipo":
          this.$http
            .get(this.$urlAPI + "/tipo/portipoato/" + this.prazo.tipoato, {
              headers: {
                authorization: "Bearer " + this.$store.getters.getToken
              }
            })
            .then(response => (this.tipos = response.data));
          break;
        case "prazo":
          this.$http
            .get(this.$urlAPI + "/prazo/" + this.prazo.id, {
              headers: {
                authorization: "Bearer " + this.$store.getters.getToken
              }
            })
            .then(response => (this.prazo = response.data));
          this.realizado =
            this.prazo.status_id == 5 || this.prazo.status_id == 6;
          break;
        case "todos":
          this.$http
            .get(this.$urlAPI + "/cidade/porestado/" + this.prazo.estado_id, {
              headers: {
                authorization: "Bearer " + this.$store.getters.getToken
              }
            })
            .then(response => (this.cidades = response.data));
          this.$http
            .get(
              this.$urlAPI +
                "/advogado/doescritorio/" +
                this.prazo.escritorio_id,
              {
                headers: {
                  authorization: "Bearer " + this.$store.getters.getToken
                }
              }
            )
            .then(response => (this.advogados = response.data));
          this.$http
            .get(this.$urlAPI + "/tipo/portipoato/" + this.prazo.tipoato, {
              headers: {
                authorization: "Bearer " + this.$store.getters.getToken
              }
            })
            .then(response => (this.tipos = response.data));
          break;
      }
    },
    salvarPendencia(acao) {
      this.pendencia.calculo_id = this.prazo.id;
      if (acao == "novo") {
        this.$http
          .post(this.$urlAPI + "/pendencia", this.pendencia, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            if (response.data.status) {
              this.carregaPendencia();
              this.NovaPendencia = false;
            } else {
              this.errospen = null;
              this.errospen = response.data.erros;
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      } else if (acao == "editar") {
        this.$http
          .post(
            this.$urlAPI + "/pendencia/" + this.pendencia.id,
            this.pendencia,
            {
              headers: {
                authorization: "Bearer " + this.$store.getters.getToken
              }
            }
          )
          .then(response => {
            if (response.data.status) {
              this.carregaPendencia();
              this.EditPendencia = false;
              //this.pendencia = response.data.pendencia;

              console.log(this.pendencia);

              if (
                this.pendencia.pendenciatipo_id == 6 &&
                this.pendencia.realizada == true
              )
                window.location.reload();
            } else {
              this.errospen = null;
              this.errospen = response.data.erros;
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      }
    },
    frmPendencia(acao, item) {
      this.$http
        .get(this.$urlAPI + "/tipopendencia", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.tipospendencia = response.data));
      if (acao == "novo") {
        this.NovaPendencia = true;
      } else {
        if (item.dataconclusao === null) {
          this.pendencia = item;
          this.EditPendencia = true;
        }
      }
    },
    carregaPendencia() {
      this.$http
        .get(this.$urlAPI + "/pendencia/" + this.$route.params.id, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.itemsPend = response.data));
    },
    carregatratamento() {
      this.$http
        .get(this.$urlAPI + "/tratamento/" + this.$route.params.id, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => {
          if (response.data.status) {
            this.PodeFinalizar = response.data.finalizar;
            if (response.data.status)
              this.itemsTrata = response.data.tratamento;
          }
        });
    },
    editarTratamento() {
      this.tratamento.calculo_id = this.$route.params.id;
      this.EditTratamento = true;
    },
    TratarPrazo() {
      this.tratar = true;
    },
    confirmaTratamento(acao) {
      //this.tab = "tabTratamento";
      this.tratamento.calculo_id = this.prazo.id;

      if (acao == "editar") {
        this.$http
          .post(
            this.$urlAPI + "/tratamento/" + this.tratamento.id,
            this.tratamento,
            {
              headers: {
                authorization: "Bearer " + this.$store.getters.getToken
              }
            }
          )
          .then(response => {
            if (response.data.status) {
              this.verificaTratamento();
              this.carregar("prazo");
            } else {
              this.errostra = null;
              this.errostra = response.data.erros;
              this.tab = "tabTratamento";
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      } else {
        this.$http
          .post(this.$urlAPI + "/tratar", this.tratamento, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            if (response.data.status) {
              this.verificaTratamento();
              this.carregar("prazo");
            } else {
              this.errostra = null;
              this.errostra = response.data.erros;
              this.tab = "tabTratamento";
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      }

      this.carregatratamento();

      this.tratar = false;
      this.NovoTratamento = false;
      this.EditTratamento = false;
    },
    FinalizarPrazo() {
      this.finalizar = true;
    },
    confirmaFinalizar() {
      this.$http
        .post(this.$urlAPI + "/prazo/finalizar/" + this.prazo.id, this.prazo, {
          headers: {
            authorization: "Bearer " + this.$store.getters.getToken
          }
        })
        .then(response => {
          if (response.data.status) {
            this.verificaTratamento();
            this.carregaPendencia();
            this.carregar("prazo");
            this.finalizar = false;
            this.prazo = response.data.prazo;
            this.realizado =
              response.data.prazo.status_id == 5 ||
              response.data.prazo.status_id == 6;
          } else {
            this.erros = null;
            this.erros = response.data.erros;
          }
        })
        .catch(e => {
          this.erros = e.response.data.erros;
        });
    },
    ConcluirPrazo() {
      this.concluir = true;
    },
    confirmaConcluir() {
      this.tratamento.calculo_id = this.prazo.id;
      this.tratamento.data = this.parseDate(this.tratamento.data);
      let usuario = this.$store.getters.getUsuario;
      if (usuario) {
        this.tratamento.user_id = usuario.id;
      }
      this.$http
        .post(this.$urlAPI + "/concluir", this.tratamento, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => {
          if (response.data.status) {
            this.tratamento.id = 0;
            this.tratamento.observacao = "";
            this.EmTratamento = false;
          } else {
            this.errostra = null;
            this.errostra = response.data.erros;
            this.tab = "tabTratamento";
          }
        })
        .catch(e => {
          this.erros = e.response.data.erros;
        });

      this.carregatratamento();
      this.concluir = false;
    },
    verificaTratamento() {
      this.tratamento.calculo_id = this.$route.params.id;
      let usuario = this.$store.getters.getUsuario;
      if (usuario) {
        this.tratamento.user_id = usuario.id;
      }
      this.$http
        .post(this.$urlAPI + "/emtratamento", this.tratamento, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => {
          this.EmTratamento = response.data.status;
          if (response.data.status) {
            this.tratamento.id = response.data.tratamento.id;
            this.tratamento.calculo_id = response.data.tratamento.calculo_id;
            this.tratamento.observacao = response.data.tratamento.observacao;
          }
        })
        .catch(e => {
          this.erros = e.response.data.erros;
        });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    esconder: function(card) {
      switch (card) {
        case "processo":
          this.dadosprocesso = !this.dadosprocesso;
          if (this.dadosprocesso) this.iconeprocesso = "mdi-minus";
          else this.iconeprocesso = "mdi-plus";
          break;

        case "solicitacao":
          this.dadossolicitacao = !this.dadossolicitacao;
          if (this.dadossolicitacao) this.iconesolicitacao = "mdi-minus";
          else this.iconesolicitacao = "mdi-plus";
          break;

        case "tratamento":
          this.dadostratamento = !this.dadostratamento;
          if (this.dadostratamento) this.iconetratamento = "mdi-minus";
          else this.iconetratamento = "mdi-plus";
          break;

        case "pendencias":
          this.dadospendencias = !this.dadospendencias;
          if (this.dadospendencias) this.iconependencias = "mdi-minus";
          else this.iconependencias = "mdi-plus";
          break;
      }
    },
    getData: function() {
      this.loading = true;
      this.$http
        .get(this.$urlAPI + "/empresa", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.empresas = response.data));
      this.$http
        .get(this.$urlAPI + "/escritorio", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.escritorios = response.data));
      this.$http
        .get(this.$urlAPI + "/estado", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.estados = response.data));
      this.$http
        .get(this.$urlAPI + "/usuario", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.usuarios = response.data));

      if (this.$route.params.id) {
        this.openform("editar", this.$route.params.id);

        this.carregatratamento();
        this.carregaPendencia();
        this.verificaTratamento();
      } else {
        this.openform("novo");
      }
    },
    openform: function(opcao, id) {
      this.frmcadastro = true;
      this.erros = [];
      if (opcao == "novo") {
        this.excluir = false;
      } else if (opcao == "editar") {
        this.excluir = true;
        this.$http
          .get(this.$urlAPI + "/prazo/" + id, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            this.prazo = response.data;
            this.prazo.datasolicitacao = this.formatDate(
              this.prazo.datasolicitacao
            );
            this.prazo.datafatal = this.formatDate(this.prazo.datafatal);
            this.realizado =
              response.data.status_id == 5 || response.data.status_id == 6;
          });

        this.carregar("todos");

        this.loading = false;
      }
    },
    salvar: function() {
      this.btnSalvar = false;
      this.prazo.datasolicitacao = this.parseDate(this.prazo.datasolicitacao);
      this.prazo.datafatal = this.parseDate(this.prazo.datafatal);
      if (this.excluir) {
        this.$http
          .post(this.$urlAPI + "/prazo/" + this.prazo.id, this.prazo, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            if (response.data.status) {
              this.$router.push("/prazo");
            } else {
              this.errosproc = null;
              this.errosproc = response.data.processo;
              this.errossolic = null;
              this.errossolic = response.data.solicitacao;
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      } else {
        this.$http
          .post(this.$urlAPI + "/prazo", this.prazo, {
            headers: { authorization: "Bearer " + this.$store.getters.getToken }
          })
          .then(response => {
            if (response.data.status) {
              if (!this.$route.params.id)
                this.mensagens.push(["Prazo Cadastrado com Sucesso!"]);
              this.$router.push("/prazo");
            } else {
              this.errosproc = null;
              this.errosproc = response.data.processo;
              this.errossolic = null;
              this.errossolic = response.data.solicitacao;
            }
          })
          .catch(e => {
            this.erros = e.response.data.erros;
          });
      }

      this.btnSalvar = true;
    },
    confirmaExcluir(opcao) {
      if (opcao == "pendencia") this.excluirPendencia = true;
      else this.exclusao = true;
    },
    deletar: function() {
      this.$http
        .delete(this.$urlAPI + "/prazo/" + this.prazo.id, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => {
          if (response.data.status) {
            this.exclusao = false;
            this.$router.push("/prazo");
          } else {
            this.erros = null;
            this.erros = response.data.erros;
          }
        })
        .catch(e => {
          this.erros = e.response.data.erros;
        });
    },
    confirmaDevolver() {
      this.devolver = true;
    },
    devolverPrazo() {
      this.devolver = false;
      this.$http
        .delete(this.$urlAPI + "/tratamento/" + this.tratamento.id, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => {
          if (response.data.status) {
            this.verificaTratamento();
            this.carregatratamento();
            this.carregar("prazo");
            this.EditTratamento = false;
          } else {
            this.errostra = null;
            this.errostra = response.data.erros;
          }
        })
        .catch(e => {
          this.erros = e.response.data.erros;
        });
    },
    deletarPendencia() {
      this.$http
        .delete(this.$urlAPI + "/pendencia/" + this.pendencia.id, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => {
          if (response.data.status) {
            this.verificaTratamento();
            this.carregaPendencia();
            this.carregar("prazo");
            this.excluirPendencia = false;
            this.EditPendencia = false;
          } else {
            this.errospen = null;
            this.errospen = response.data.erros;
          }
        })
        .catch(e => {
          this.erros = e.response.data.erros;
        });
    }
  }
};
</script>

<style scoped>
.row-form {
  margin-bottom: -22px;
  margin-top: -10px;
}

.tbTitle {
  height: 50px;
}
</style>